import * as Yup from 'yup';
import { DictPhysicalStorage } from '@models';

export function useValidationSchema() {
  return Yup.object<DictPhysicalStorage>().shape({
    name: Yup.string().nullable().required(),
  });
}
